import { getRequestApi } from "../libs/request";

const headers = {
    "X-MBX-APIKEY": process.env.REACT_APP_BINANCE_API_KEY,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true
    //"Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS"
}

const getTickerPrice = async (symbols) => {
    const symbolNames = [...new Set(symbols.map(s => s.symbol))];
    const url = `${process.env.REACT_APP_BINANCE_SPOT_API_BASE_URL}/ticker/price?symbols=${encodeURIComponent(JSON.stringify(symbolNames))}`;

    const result = await getRequestApi(url);
    const prices = new Map(result.map(r => [r.symbol, r.price]));

    return symbols.map(({ symbol, market }) => ({
        symbol,
        price: prices.get(symbol) ?? 0,
        market
    }));
};

const getFuturesKlines = async (symbol, interval, limit = 1) => {
    let url = `${process.env.REACT_APP_BINANCE_FUTURES_API_BASE_URL}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`;
    return getRequestApi(url, {}, headers);
}

const getFuturesKlinesWithDate = async (symbol, interval, limit = 1, startTime, endTime = Date.now()) => {
    let url = `${process.env.REACT_APP_BINANCE_FUTURES_API_BASE_URL}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}&startTime=${startTime}&endTime=${endTime}`;
    return getRequestApi(url, {}, headers);
}

const getSpotKlines = async (symbol, interval, limit = 1) => {
    let url = `${process.env.REACT_APP_BINANCE_SPOT_API_BASE_URL}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}`;
    return getRequestApi(url);
}

const getSpotKlinesWithDate = async (symbol, interval, limit = 1, startTime, endTime = Date.now()) => {
    let url = `${process.env.REACT_APP_BINANCE_SPOT_API_BASE_URL}/klines?symbol=${symbol}&interval=${interval}&limit=${limit}&startTime=${startTime}&endTime=${endTime}`;
    return getRequestApi(url);
}

export const binanceService = {
    getTickerPrice,
    getFuturesKlines,
    getFuturesKlinesWithDate,
    getSpotKlines,
    getSpotKlinesWithDate
};
